export default "__VITE_ASSET__Diz76yOs__"